module.exports = __webpack_public_path__ + "static/media/Chrissy Charlton.cf72da5d.png";